import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SelfServiceService {
  private apiUrl = environment.apiUrl;
  public deleteplaybookRecord = new BehaviorSubject<any>(null);
  editSelfHelpPlaybook = new BehaviorSubject<any>(null);

  constructor(public http: HttpClient) { }


  public getSelfHelpecord() {
    const selfHelpUrl = `${this.apiUrl}/ava/aipo/accelerator/selfhelp/api/v1/template/get`;
    return this.http.get(selfHelpUrl);
  }

  public editSelfPlaybook(selfhelpId: any, payload: any) {
    const apiUrl = `${this.apiUrl}/ava/aipo/accelerator/selfhelp/api/v1/template/update?selfhelpId=${selfhelpId}`;
    return this.http.put(apiUrl, payload)
  }

  public submitSelfHelpPlaybook(payload: any) {
    let url = `${this.apiUrl}/ava/aipo/accelerator/selfhelp/api/v1/template/save`;
    return this.http.post(url, payload)
  }

  public getWorkflowById(selfhelpId: number) {
    let url = `${this.apiUrl}/ava/aipo/accelerator/selfhelp/api/v1/template/get/id?selfHelpId=${selfhelpId}`;
    return this.http.get(url)
  }
  public decommissionServiceSubmit(payload: any) {
    let apiUrl = `${this.apiUrl}/ava/aipo/accelerator/selfhelp/api/v1/decommission`;
    return this.http.post(apiUrl, payload)
  }

  public deleteSelfHelpPlaybook(selfhelpId: number) {
    const apiUrl = `${this.apiUrl}/ava/aipo/accelerator/selfhelp/api/v1/template/delete?selfhelpId=${selfhelpId}`;
    return this.http.delete(apiUrl);
  }

  public getJobDetailsforSelfhelp(jobRunId: number) {
    let url = `${this.apiUrl}/ava/aipo/accelerator/selfhelp/api/v1/job/details?jobRunId=${jobRunId}`;
    return this.http.get(url);
  }

  public getConfigparamsById(selfhelpId: number) {
    let url = `${this.apiUrl}/ava/aipo/accelerator/selfhelp/api/v1/config/get?selfhelpId=${selfhelpId}`;
    return this.http.get(url)
  }

  public startAWXTemplate(selfHelpId:number,payload: any) {
    let url = `${this.apiUrl}/ava/aipo/accelerator/selfhelp/api/v1/start/${selfHelpId}`;
    return this.http.post(url, payload);
  }

}
